export { default as NavSectionVertical } from './vertical';
export { default as NavSectionHorizontal } from './horizontal';

export function isExternalLink(path) {
  return path.includes('http');
}

export function getActive(path, pathname, asPath, siblings=[]) {
  return pathname.includes(path) || asPath.includes(path) || siblings.includes(pathname) || siblings.includes(asPath);
}

export function getActiveCompany(id, asPath) {
  return asPath.includes(`?c=${id}`);
}
